// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export const CONSENT_POLICY_VERSION = "v1"
const STORAGE_KEY = "bb_pending_consent"

export interface PendingConsentRecord {
  email: string
  policyVersion: string
  acceptedAt: string
}

/**
 * Records consent locally at signup time (checkbox + policy version).
 *
 * ADR-014 specifies consent is persisted server-side into
 * `consent_records` on the first `/v1/me` bootstrap call — but
 * @bitebalance/contracts (T04) has no consent-recording request field yet.
 * Rather than silently drop the checkbox's meaning (AGENTS.md forbids
 * silently reducing scope), this stub records it locally so a later T09+
 * change can forward it once the contract exists; it is not a substitute
 * for server-side consent recording.
 */
export function recordPendingConsent(email: string): void {
  const record: PendingConsentRecord = {
    email,
    policyVersion: CONSENT_POLICY_VERSION,
    acceptedAt: new Date().toISOString(),
  }
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record))
  } catch {
    // Non-fatal: signup itself still succeeds without local persistence.
  }
}

export const CONSENT_POLICY_VERSION_LABEL = CONSENT_POLICY_VERSION
